import { SimpleEntityActions } from '@app/classes';
import { ModelMixin } from '../core/base-generic.model';

export class JobBoard extends ModelMixin<JobBoard>() {
    static permission = new SimpleEntityActions('jobBoard');

    protected static _resource = 'applicantTracker/board';
    protected static _version = 'v2';

    protected static _datetimes = ['createdAt', 'updatedAt', 'deletedAt'];

    protected static _serializeAttributes = [
        'companySlug',
        'title',
        'companyUrl',
        'successMessage',
        'logoId',
        'customCss',
        'customCssUrl',
        'buttonColor',
        'pageColor',
        'advancedStyles',
        'companyId',
    ];

    get companySlug(): string {
        return this._attributes['companySlug'];
    }

    set companySlug(val: string) {
        this._attributes['companySlug'] = val;
    }

    get logoId(): number | null {
        return this._attributes['logoId'];
    }

    set logoId(val: number) {
        this._attributes['logoId'] = val;
    }

    get title(): string {
        return this._attributes['title'];
    }

    set title(val: string) {
        this._attributes['title'] = val;
    }

    get companyUrl(): string {
        return this._attributes['companyUrl'];
    }

    set companyUrl(val: string) {
        this._attributes['companyUrl'] = val;
    }

    get successMessage(): string {
        return this._attributes['successMessage'];
    }

    set successMessage(val: string) {
        this._attributes['successMessage'] = val;
    }

    get buttonColor(): string {
        return this._attributes['buttonColor'];
    }

    set buttonColor(val: string) {
        this._attributes['buttonColor'] = val;
    }

    get pageColor(): string {
        return this._attributes['pageColor'];
    }

    set pageColor(val: string) {
        this._attributes['pageColor'] = val;
    }

    get customCss(): string {
        return this._attributes['customCss'];
    }

    set customCss(val: string) {
        this._attributes['customCss'] = val;
    }

    get customCssUrl(): string {
        return this._attributes['customCssUrl'];
    }

    set customCssUrl(val: string) {
        this._attributes['customCssUrl'] = val;
    }

    set advancedStyles(val: boolean) {
        this._attributes['advancedStyles'] = val;
    }

    get logoFile(): File {
        return this._attributes['logoFile'];
    }

    set logoFile(val: File) {
        this._attributes['logoFile'] = val;
    }

    /* Timestamps */
    get createdAt(): any {
        return this._attributes['created_at'];
    }

    get updatedAt(): any {
        return this._attributes['updated_at'];
    }

    get deletedAt(): any {
        return this._attributes['deleted_at'] || null;
    }

    get archivedAt(): any {
        return this._attributes['archived_at'] || null;
    }

    get companyId(): number {
        return this._attributes['companyId'];
    }

    set companyId(val: number) {
        this._attributes['companyId'] = val;
    }
}
